import {
    suggestNextSteps,
    summarize,
    summarizeAndReply,
    showKeyTakeaways,
    showRelatedResources,
    needsUrgentReplies,
    type Suggestion,
    type Suggestions,
} from '../utils/suggestionCatalog';
import { isUserCommercialPremium } from './isUserCommercialPremium';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Helper function to navigate the A/B/C/D experiment structure for selected reading pane suggestions.
 * Three strings are being tested, split into three flights.
 * Flight name structure is: copilot-dab-mail-rp-sua-treatment-A, -B, -C
 *
 * Note that the first two suggestions are always static, with only the third suggestion changing based on flight.
 */
export function getSelectedReadingPaneSuggestions(): Suggestions {
    let dynamicThirdSuggestion: Suggestion;

    if (!isUserCommercialPremium()) {
        // Non-Commercial Premium users are excluded from the SUA reading pane experiment,
        // just return original set of three suggestions
        return [summarize, summarizeAndReply, suggestNextSteps];
    }

    // Otherwise, check for experiment flights
    if (isFeatureEnabled('copilot-dab-mail-rp-sua-treatment-A')) {
        dynamicThirdSuggestion = showKeyTakeaways;
    } else if (isFeatureEnabled('copilot-dab-mail-rp-sua-treatment-B')) {
        dynamicThirdSuggestion = showRelatedResources;
    } else if (isFeatureEnabled('copilot-dab-mail-rp-sua-treatment-C')) {
        dynamicThirdSuggestion = needsUrgentReplies;
    } else {
        dynamicThirdSuggestion = suggestNextSteps;
    }

    return [summarize, summarizeAndReply, dynamicThirdSuggestion];
}
